import { cx } from 'emotion';
import { isNil } from 'ramda';
import {
  CSSProperties, forwardRef, ReactNode, useEffect,
  useState,
} from 'react';

import { panelBody, panelContainer } from './Drawer.css';

type DrawerPanelProps = {
  width?: string | number;
  height?: string | number;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  open: boolean;
  hideContentOnClose: boolean;
}

export const DrawerPanel = forwardRef(({
  children,
  className,
  width,
  height,
  style,
  open,
  hideContentOnClose,
}: DrawerPanelProps) => {
  const [ hideContent, setHideContent ] = useState(!open);

  const containerStyle: CSSProperties = {
    ...style,
    ...(!isNil(width) && { width }),
    ...(!isNil(height) && { height }),
    ...(hideContentOnClose && hideContent && { contentVisibility: 'hidden', visibility: 'hidden' }),
  };

  useEffect(() => {
    if (open) {
      setHideContent(false);
    }
  }, [ open ]);

  const handleTransitonEnd = () => {
    if (!open) {
      setHideContent(true);
    }
  };

  return (
    <div
      style={containerStyle}
      className={cx(panelContainer, className)}
      data-name="panel"
      onTransitionEnd={handleTransitonEnd}
    >
      {children}
    </div>
  );
});

type DrawerBodyProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const DrawerBody = ({
  children,
  className,
  style,
}: DrawerBodyProps) => (
  <div
    className={cx(panelBody, className)}
    style={style}
  >
    {children}
  </div>
);
